import { render, staticRenderFns } from "./PointProgramsNewProgramContest.vue?vue&type=template&id=595046be&scoped=true&"
import script from "./PointProgramsNewProgramContest.vue?vue&type=script&lang=js&"
export * from "./PointProgramsNewProgramContest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "595046be",
  null
  
)

export default component.exports